import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rbccompletion-dashboard',
  templateUrl: './rbccompletion-dashboard.component.html',
  styleUrls: ['./rbccompletion-dashboard.component.scss']
})
export class RBCCompletionDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
